import { procurementAPI } from "../../axios";

export const actions = {

    //RfqPostingFile
    GetRfqPostingFiles(context, data){
        return procurementAPI.get(`RfqPostingFile/PublicPostedRfq/${data}`);
    },
    GetSingleRfqPostingFiles(context, data){
        return procurementAPI.get(`RfqPostingFile/${data}`);
    },
    CreateRfqPostingFile(context, data){
        return procurementAPI.post(`RfqPostingFile`, data);
    },
    UpdateRfqPostingFile(context, data){
        return procurementAPI.put(`RfqPostingFile/${data.id}`, data);
    },
    DeleteRfqPostingFile(context, data){
        return procurementAPI.delete(`RfqPostingFile/${data}`);
    }
}